module.exports = "/_next/static/images/photoEugeniuCupcinenco-ebbf0cf856cca25f3a20a4ae5864d3a9.webp";